import {
  ListingModalOptionProvider,
  ListingModalPlanContentWrapper,
  ListingModalPlanOptionsSubtitle,
  ListingModalPlanOptionsTitle,
  ListingModalPlanOptionsWrapper,
  ListingModalPlanRedirect,
} from "../listingModalPlanOptions";
import { SecondaryButton } from "../../../../global/buttons/material/secondaryButton/SecondaryButton";
import { Check } from "@mui/icons-material";
import { ListingModalOneTimeOption } from "../listingModalPlanOptions/ListingModalOneTimeOption";
import Link from "next/link";
import React from "react";
import { useOnetimeBuyVerifyPurchase } from "../../../../../hooks/trainingPlan";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

export const ListingOneTimeHidden = () => {
  const currentListing = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const isPurchased = useOnetimeBuyVerifyPurchase({
    currentListing: currentListing,
  });

  return (
    <ListingModalPlanOptionsWrapper>
      <ListingModalPlanOptionsTitle>Get Started</ListingModalPlanOptionsTitle>

      <ListingModalPlanOptionsSubtitle>
        Purchase this training plan
      </ListingModalPlanOptionsSubtitle>

      <ListingModalPlanContentWrapper>
        {isPurchased && (
          <SecondaryButton startIcon={<Check />} title="In your library" />
        )}

        <ListingModalOptionProvider>
          <ListingModalOneTimeOption useSecondaryButton={false} />
        </ListingModalOptionProvider>
      </ListingModalPlanContentWrapper>

      <Link href={"/payment"}>
        <ListingModalPlanRedirect>
          Upgrade Your Membership
        </ListingModalPlanRedirect>
      </Link>
    </ListingModalPlanOptionsWrapper>
  );
};
